<template>
  <div
    v-if="isVisible"
    class="position-fixed center p-3"
    style="z-index: 9999; left: 50%; transform: translate(-50%, 0px)"
    :class="position"
  >
    <div
      class="toast align-items-center text-white border-0"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      ref="toast"
      :class="options.bgClass"
    >
      <div class="d-flex">
        <div class="toast-body" :class="options.bgClass">{{ message }}</div>
        <button
          type="button"
          class="btn-close btn-close-white me-2 m-auto"
          @click="close"
          aria-label="Close"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "bootstrap";
export default {
  data() {
    return {
      toast: null,
      resolve: null,
      reject: null,
      message: "",
      show: null,
      hide: null,
      options: {
        bgClass: "bg-primary",
      },
      isVisible: false,
    };
  },

  props: {
    // bgClass: {
    //   type: String,
    //   default: "bg-primary",
    // },

    position: {
      type: String,
      default: "bottom-0",
    },
  },

  methods: {
    open(data, options = {}) {
      this.message = data.message;
      this.options = Object.assign(this.options, options);

      this.isVisible = true;

      clearTimeout(this.show);
      clearTimeout(this.hide);

      this.show = setTimeout(() => {
        this.$nextTick(() => {
          this.toast = new Toast(this.$refs.toast);
          this.toast.show();
        });
      }, 50);

      this.hide = setTimeout(() => {
        this.toast?.hide();
        this.isVisible = false;
        this.toast = null;
      }, 5000);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    // agree() {
    //   this.resolve(true);
    //   // this.dialog = false;
    //   this.toast.hide();
    // },
    close() {
      this.resolve(false);
      clearTimeout(this.hide);

      this.toast?.hide();
      this.toast = null;
      this.isVisible = false;
    },
  },

  mounted() {},
  beforeUnmount() {
    clearTimeout(this.show);
    clearTimeout(this.hide);

    this.show = null;
    this.hide = null;

    if (this.toast) {
      try {
        this.toast.dispose();
      } catch (e) {
        console.error(e.message);
      }
      this.toast = null;
    }
  },
};
</script>

<style scoped>
.toast-body {
  max-width: 90% !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
</style>
